<!-- 矿山管理，bluesky:2023-09-27 -->
<template>
  <div class="manage-section">

    <div class="breadcrumb-wrap">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>管理后台</el-breadcrumb-item>
        <el-breadcrumb-item>矿山管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 搜索-start -->
    <div class="search-wrap">

      <div class="search-item">
          <div class="btn-list-wrap">
              <el-button type="info" @click="clickAdd">添加</el-button>
          </div>
      </div>

      <div class="search-item">
        <label for="areaSelect">省市区：</label>
        <el-cascader
              id="areaSelect"
              size="large"
              :options="options"
              v-model="selectedOptions"
              @change="handleChange">
        </el-cascader>
      </div>
      <div class="search-item">
        <label class="label" for="keyword">关键词：</label>
        <el-input placeholder="请输入关键词" id="keyword" v-model="search.keyword" @keyup.enter.native="clickSearch"></el-input>
      </div>
      <div class="search-item">
        <el-button type="primary" @click="clickSearch">搜索</el-button>
      </div>
    </div>
    <!-- 搜索-end -->

    <!-- 表格-start -->
    <div class="table-wrap">
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="id"
            label="编号"
            >
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            >
          </el-table-column>
          <el-table-column
            prop="type"
            label="省市区">
            <template slot-scope="{row}">
            	<div>{{row.province + row.city + row.district}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="owner"
            label="采矿权人"
            >
          </el-table-column>
          <el-table-column
            prop="ore"
            label="开采矿种"
            >
          </el-table-column>
          <el-table-column
            prop="scale"
            label="生产规模"
            >
          </el-table-column>
          <el-table-column
            prop="name"
            label="有效期限"
            >
            <template slot-scope="{row}">
              {{row.startTime}}至{{row.endTime}}
            </template>
          </el-table-column>
          <el-table-column
            prop="exploitateStyle"
            label="开采方式"
            >
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="添加时间"
            >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="修改时间"
            >
          </el-table-column>
          <el-table-column
          	label="状态">
          	<template slot-scope="{row}">
          		{{ row.status == 1 ? "启用": "停用"}}
          	</template>
          </el-table-column>
          <el-table-column
          	label="操作">
              <template slot-scope="{row}">
                  <div class="flex-center operate">
                      <!-- <el-button type="info" size="mini" @click="clickToggle(row.id,row.status)">{{ row.status == 1?"停用":"启用" }}</el-button> -->
                      <el-button type="info" size="mini" @click="clickEdit(row.id)">修改</el-button>
                      <el-button type="info" size="mini" @click="clickDelete(row.id)">删除</el-button>
                  </div>
              </template>
          </el-table-column>
        </el-table>

       <div class="pager-wrap">
         <el-pagination
             background
             layout="prev, pager, next"
         	@current-change="pageChange"
          :page-size="search.pageSize"
             :total="totalCount">
         </el-pagination>
       </div>

    </div>
    <!-- 表格-end -->

    <el-dialog :visible.sync="isShowPopup" width="800px">
    	<div class="popup-title" slot="title">{{idInput?'修改':'添加'}}食物</div>
    	<addOrEditMine :idInput="idInput" @close="closePopup" @success="finishPublish" v-if="isShowPopup"></addOrEditMine>
    </el-dialog>

  </div>
</template>

<script>
  import { regionDataPlus, CodeToText } from 'element-china-area-data'
  import addOrEditMine from '@/page/components/addOrEditMine.vue';
  export default {
    components:{
      addOrEditMine,// 添加/修改矿山
    },
    data() {
      return {

        search:{
          keyword:null,// 关键词
          province:null,// 省
          city:null,// 市
          district:null,// 区
          pageSize:10,// 每页显示数量
          pageIndex:1,// 页码
        },
        totalCount:0,// 总数量
        totalPageCount:0,//总页码数
        options: regionDataPlus ,
        selectedOptions: [],

        tableData: [],

        isShowPopup:false,// 是否显示弹窗
        idInput:null,// 修改时传入ID
      }
    },
    mounted() {
      this.getList();
    },
    methods:{
      //改变页码
      pageChange(pageIndex){
      	this.search.pageIndex = pageIndex;
      	this.getList();
      },
      // 点击搜索
      clickSearch(){
        this.search.pageIndex = 1;
        this.getList();
      },
      //获取列表
      getList(){
      	this.$apis.get('/admin/mine/page', this.search).then(res => {
      		console.log("res",res);
          if(res.data.code == 200){
      			this.tableData = res.data.data.list;
      			this.totalPageCount = res.data.data.totalPageCount;
            this.totalCount = res.data.data.totalCount;
      		}
      		else{
      			this.$message({
      			    message:res.data.data,
      			    type:'error'
      			});
      		}
      	});
      },

      // 省市区改变
          handleChange (value) {
              console.log(value)

                if (
                  value[0] != null &&
                  value[1] != null &&
                  value[2] != null
                ) {
                  this.search.province = CodeToText[value[0]];
                  this.search.city = CodeToText[value[1]];
                  this.search.district = CodeToText[value[2]];
                  this.search.pageIndex = 1;
                  this.getList();

                  const str =
                    CodeToText[value[0]] +
                    '/' +
                    CodeToText[value[1]] +
                    '/' +
                    CodeToText[value[2]]
                  console.log(str)
                }

                if(value[0] === ""){
                  this.search.province = "";
                  this.search.city = "";
                  this.search.district = "";
                  this.getList();
                }


                },


                //添加
                clickAdd(){
                	this.isShowPopup = true;
                	this.idInput = null;
                },
                //修改
                clickEdit(id){
                	this.isShowPopup = true;
                	this.idInput = id;
                },
                //启用、停用
                clickToggle(id,oldStatus){
                	this.$confirm(`你确定要继续吗？`, '提示', {
                		confirmButtonText: '确定',
                		cancelButtonText: '取消',
                		type: 'warning'
                	}).then(() => {
                		this.$apis.post('/admin/mine/toggle', {
                			id:id,
                      status:oldStatus == 1 ? 0 : 1,
                		}).then((res) => {
                			if (res.data.code == 200) {
                				this.getList();
                				this.$message.success('操作成功！');
                			}
                			else{
                				this.$message({
                				    message:res.data.data,
                				    type:'error'
                				});
                			}
                		})
                	}).catch(() => {});
                },
                // 删除
                clickDelete(id){
                	this.$confirm(`你确定要继续吗？`, '提示', {
                		confirmButtonText: '确定',
                		cancelButtonText: '取消',
                		type: 'warning'
                	}).then(() => {
                		this.$apis.get('/admin/mine/delete', {
                			id:id,
                		}).then((res) => {
                			if (res.data.code == 200) {
                				this.getList();
                				this.$message.success('操作成功！');
                			}
                			else{
                				this.$message({
                				    message:res.data.data,
                				    type:'error'
                				});
                			}
                		})
                	}).catch(() => {});
                },
                //完成添加/修改操作后的回调
                finishPublish(){
                	this.isShowPopup = false;
                	this.getList();
                },
                //关闭弹窗
                closePopup(){
                	this.isShowPopup = false;
                },


                },
  }
</script>

<style type="scss">

</style>



// WEBPACK FOOTER //
// src/page/mineManage.vue